import axios from "axios";
import { GUEST_INFO, X_Tenant_Id } from "common/constant";
import authServices from "./auth";

export const BASE_URL = "https://api.getrichpos.com";

const axiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  timeout: 200000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async function (config: any) {
    config.headers[X_Tenant_Id] = sessionStorage.getItem(X_Tenant_Id);
    config.headers.authorizer = JSON.parse(
      sessionStorage.getItem(GUEST_INFO) || "{}"
    )?.accessToken;
    return config;
  },
  function (error: any) {
    // Do something with request error
    return Promise.reject(error);
  }
);

let refreshTokenPromise: null | Promise<any>;

axiosInstance.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async (err: any) => {
    if (axios.isCancel(err)) {
      return Promise.reject(err);
    }
    if (err.response.status === 401 || err.response.status === 403) {
      const { refreshToken } = JSON.parse(
        sessionStorage.getItem(GUEST_INFO) || "{}"
      );
      const { messageKey } = err.response.data;
      if (
        messageKey === "TokenExpired" ||
        messageKey === "GeneralUnauthorized" ||
        messageKey === "TokenIsExpired"
      ) {
        if (!refreshTokenPromise) {
          refreshTokenPromise = authServices
            .refreshToken({ refreshToken })
            .then((tokenRes: any) => {
              refreshTokenPromise = null;
              return tokenRes?.data?.data;
            })
            .catch((error) => {
              console.log(error);
            });
        }

        return refreshTokenPromise.then((token) => {
          try {
            err.config.headers.authorizer = token;
            const guestInfo = JSON.parse(
              sessionStorage.getItem(GUEST_INFO) || "{}"
            );
            guestInfo.accessToken = token;
            sessionStorage.setItem(GUEST_INFO, JSON.stringify(guestInfo));
            return axiosInstance.request(err.config);
          } catch (err) {
            console.log(err);
          }
        });
      }
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
